import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import qrImg from '/assets/images/qr-code.png'; // Adjust the path as necessary
import './YouthServices.css';
import qrImg from '../assets/qr_code.webp';

const Youth = () => {
    const [plans, setPlans] = useState([]);
    const [formVisible, setFormVisible] = useState(false);
    const [formData, setFormData] = useState({
        fullname: '',
        mobile: '',
        email: '',
        plan_id: '',
        plan_name: '',
        amount: '',
        address: '',
        city: '',
        state: '',
        country: 'India',
        pincode: '',
        start_date: '',
        end_date: '',
        frequency: 'month',
        readOnly: true
    });

    const current_date = new Date();
    const startDate = new Date(current_date);
    startDate.setDate(startDate.getDate() + 2);
    const endDate = new Date(current_date);
    endDate.setFullYear(endDate.getFullYear() + 100);

    useEffect(() => {
        const fetchPlans = async () => {
            const response = await axios.get('https://iskconujjain.com/emandate/get_plans.php');
            setPlans(response.data);
        };
        fetchPlans();

        setFormData(prev => ({
            ...prev,
            start_date: startDate.toISOString().split('T')[0],
            end_date: endDate.toISOString().split('T')[0]
        }));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handlePlanChange = (e) => {
        const selectedId = e.target.value;
        const selectedPlan = plans.find(p => p.plan_id === selectedId);

        if (!selectedPlan) return;

        if (selectedPlan.plan_name === 'Any Amount') {
            setFormData(prev => ({
                ...prev,
                plan_id: selectedId,
                plan_name: 'General Donation Any Amount',
                amount: '',
                readOnly: false
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                plan_id: selectedId,
                plan_name: selectedPlan.plan_name,
                amount: selectedPlan.amount,
                readOnly: true
            }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = 'https://iskconujjain.com/emandate/details-page.php';

        Object.entries(formData).forEach(([key, value]) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
    };

    return (
        <div className="container mt-5">
            <div className="text-center">
                <h1>Monthly Youth Preaching Seva</h1>
                <button className="btn text-white fw-bold px-4 py-2 rounded-pill mt-3" style={{
                    display: "inline-block",
                    textDecoration: "none",
                    color: "white",
                    background: "linear-gradient(1deg, #152750, #152750)",
                    padding: "0.6rem 1.4rem",
                    borderRadius: "50px",
                    fontWeight: 600,
                    transition: "background 0.3s ease"
                }}
                onClick={() => setFormVisible(!formVisible)}>
                Subscribe for Monthly Donation
            </button>
        </div>

            {
        formVisible && (
            <form className="row g-3 mt-4" onSubmit={handleSubmit} style={{ backgroundColor: '#f4f1ff', padding: '20px', borderRadius: '10px' }}>
                <div className="col-md-4">
                    <label className="form-label">Name</label>
                    <input className="form-control" name="fullname" value={formData.fullname} onChange={handleChange} required />
                </div>
                <div className="col-md-4">
                    <label className="form-label">Mobile</label>
                    <input className="form-control" name="mobile" value={formData.mobile} onChange={handleChange} required />
                </div>
                <div className="col-md-4">
                    <label className="form-label">Email</label>
                    <input type="email" className="form-control" name="email" value={formData.email} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Select Plan</label>
                    <select className="form-control" name="plan_id" value={formData.plan_id} onChange={handlePlanChange} required>
                        <option value="">Select any one</option>
                        {plans.map((plan) => (
                            <option key={plan.plan_id} value={plan.plan_id}>
                                {plan.plan_name === 'Any Amount' ? 'General Donation Any Amount' : plan.plan_name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Amount</label>
                    <input
                        className="form-control"
                        name="amount"
                        value={formData.amount}
                        onChange={handleChange}
                        readOnly={formData.readOnly}
                        required
                        type="number"
                    />
                </div>
                <div className="col-md-9">
                    <label className="form-label">Address</label>
                    <input className="form-control" name="address" value={formData.address} onChange={handleChange} required />
                </div>
                <div className="col-md-3">
                    <label className="form-label">City</label>
                    <input className="form-control" name="city" value={formData.city} onChange={handleChange} required />
                </div>
                <div className="col-md-4">
                    <label className="form-label">State</label>
                    <input className="form-control" name="state" value={formData.state} onChange={handleChange} required />
                </div>
                <div className="col-md-4">
                    <label className="form-label">Country</label>
                    <select className="form-control" name="country" value={formData.country} onChange={handleChange} required>
                        <option value="India">India</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <label className="form-label">PIN Code</label>
                    <input className="form-control" name="pincode" value={formData.pincode} onChange={handleChange} required />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Start Date</label>
                    <input type="date" className="form-control" name="start_date" value={formData.start_date} min={formData.start_date} onChange={handleChange} required />
                </div>
                <input type="hidden" name="end_date" value={formData.end_date} />
                <div className="col-md-6">
                    <label className="form-label">Frequency</label>
                    <select className="form-control" name="frequency" value={formData.frequency} onChange={handleChange} required>
                        <option value="month">Monthly</option>
                    </select>
                </div>
                <div className="col-12 text-center">
                    <button type="submit" className="btn btn-primary" style={{                    background: "linear-gradient(1deg, #152750, #152750)",
            }}>Proceed</button>
                </div>
            </form>
        )
    }

    <div className="ys-account-box">
        <div className="ys-qr-container">
            <img src={qrImg} alt="QR Code" className="ys-qr" />
        </div>
        <div className="ys-account-details">
            <h3>Account Details</h3>
            <p><strong>Name</strong> - ISKCON YES BANK</p>
            <p><strong>Number</strong> - 038194600000480</p>
            <p><strong>IFSC</strong> - YESB0000381</p>
            <p><strong>UPI</strong> - iskconyouth@yesbank</p>
            <p>Freeganj Branch Ujjain</p>
        </div>
    </div>
        </div >
    );
};

export default Youth;
